"use client";

import "./globals.css";
import { useEffect } from "react";
import ErrorPageShell from "@/components/ErrorPageShell";
import {
  GLOBAL_RUNTIME_ERROR_FALLBACK,
  GLOBAL_RUNTIME_ERROR_SKIP_LABEL,
} from "@/lib/content/entries/runtime-error-fallback";
import { DEVICE_SHELL_ATTRIBUTE } from "@/lib/device/shell";

type GlobalErrorProps = {
  error: Error & { digest?: string };
  unstable_retry: () => void;
};

export default function GlobalError({ error, unstable_retry }: GlobalErrorProps) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <html lang="en" dir="ltr" data-bs-theme="dark">
      <body {...{ [DEVICE_SHELL_ATTRIBUTE]: "desktop" }}>
        <ErrorPageShell
          content={GLOBAL_RUNTIME_ERROR_FALLBACK}
          digest={error.digest}
          includeDocumentMetadata
          onRetry={unstable_retry}
          skipLabel={GLOBAL_RUNTIME_ERROR_SKIP_LABEL}
        />
      </body>
    </html>
  );
}
